<script>

const pixelRatio = Math.min(2, window.devicePixelRatio)

function multiplyPixelRatio () {
  let values = []
  for (let i = 0, numArguments = arguments.length; i < numArguments; i++) {
    values.push(arguments[i] * pixelRatio)
  }
  return values.join(' ')
}

export default {
  name: 'BaTrendPathCanvasItem',
  components: {
  },
  props: {
    id: {
      type: String,
      required: true
    },
    lineInfo: {
      type: Object,
      required: true
    },
    nodeItemBorderRadius: {
      type: Number,
      default: 0
    },
    hasThruPath: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    isThruPath: {
      type: Boolean,
      default: false
    },
    isInterrupted: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  watch: {
    isActive (value) {
      !value && this.$parent.deactivateChild(this)
    }
  },
  computed: {
    pathDescription () {
      let { fromX, fromY, toX, toY, widthOut, widthIn } = this.lineInfo

      const trimX = fromX - this.nodeItemBorderRadius
      fromX -= trimX
      toX -= trimX

      const nodeGap = (toX - fromX)
      const centerX = fromX + nodeGap / 2
      const borderRadius = this.nodeItemBorderRadius
      const description = []

      fromX -= borderRadius
      toX += borderRadius

      const moveValue = nodeGap * 0.125

      if (this.isInterrupted && !this.isActive) {
        description.push(
          'M', multiplyPixelRatio(fromX, fromY),
          'L', multiplyPixelRatio(fromX + borderRadius + moveValue, fromY),
          'L', multiplyPixelRatio(fromX + borderRadius + moveValue, fromY + widthOut),
          'L', multiplyPixelRatio(fromX, fromY + widthOut),
          'Z',
          'M', multiplyPixelRatio(toX, toY),
          'L', multiplyPixelRatio(toX - borderRadius - moveValue, toY),
          'L', multiplyPixelRatio(toX - borderRadius - moveValue, toY + widthOut),
          'L', multiplyPixelRatio(toX, toY + widthOut),
          'Z'
        )
      } else {
        description.push(
          'M', multiplyPixelRatio(fromX, fromY),
          'L', multiplyPixelRatio(fromX + borderRadius + moveValue, fromY),
          'C', multiplyPixelRatio(centerX, fromY, centerX, toY, toX - moveValue, toY),
          'L', multiplyPixelRatio(toX, toY, toX, toY + widthIn, toX - moveValue, toY + widthIn),
          'C', multiplyPixelRatio(centerX, toY + widthIn, centerX, fromY + widthOut, fromX + borderRadius + moveValue, fromY + widthOut),
          'L', multiplyPixelRatio(fromX, fromY + widthOut),
          'Z'
        )
      }

      return description.join(' ')
    }
  },
  render () {
    return null
  }
}
</script>
